export default __webpack_public_path__ + "static/media/product_08.efc6c719.jpg";